import { useCapacitorAppInfo } from '@/hooks/useCapacitorAppInfo';
import { useEffect, useRef } from 'react';
import { useTracking } from 'react-tracking';

type Props = {
  page?: string;
};

export const useAppUpdateBoundaryTracking = ({ page }: Props = {}) => {
  const hasTracked = useRef(false);
  const { Track, trackEvent } = useTracking({
    type: 'track',
    subject: 'outdated-app',
    action: 'landed',
    ...(page ? { page } : {}),
  });

  const { data, status } = useCapacitorAppInfo();
  const { version } = data ?? {};

  const shouldTrack = status !== 'pending';

  useEffect(() => {
    if (!shouldTrack || hasTracked.current) return;

    trackEvent({
      version,
    });
    hasTracked.current = true;
  }, [trackEvent, version, shouldTrack]);

  return {
    Track,
    trackEvent,
  };
};
